import React from 'react';

export const BackspaceShortcut = () => {
  return (
    <svg
      width="25"
      height="17"
      viewBox="0 0 25 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginTop: '-8px' }}
    >
      <path
        d="M23.7913 12.901V3.81768C23.7913 1.99347 22.3125 0.514648 20.4883 0.514648H8.98085C8.16329 0.514648 7.37478 0.817852 6.76785 1.36561L1.73553 5.90727C0.282153 7.21895 0.282155 9.49974 1.73553 10.8114L6.76785 15.3531C7.37478 15.9008 8.16329 16.204 8.98085 16.204H20.4883C22.3125 16.204 23.7913 14.7252 23.7913 12.901Z"
        stroke="#000000"
        strokeWidth="1.4"
      />
      <path
        d="M11.4067 5.08838L16.8608 10.5425"
        stroke="#000000"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M16.8589 5.08789L11.4048 10.542"
        stroke="#000000"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
